import { useState } from "react";
import { useAuth } from "../context/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await fetch(`${API}/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      if (!res.ok) {
        let detail = null;
        try {
          const errorData = await res.json();
          detail = errorData.detail;
        } catch (_) {}
        if (detail) {
          throw new Error(detail);
        } else if (res.status === 401) {
          throw new Error("Forkert email eller password");
        } else {
          throw new Error("Serverfejl — prøv igen");
        }
      }

      const data = await res.json();
      login(data.token, data.user, rememberMe);
    } catch (err) {
      setError(err.message || "Noget gik galt. Prøv igen.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#09090b",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "2rem 1rem",
        fontFamily: "'Inter', sans-serif",
      }}
    >
      <div style={{ width: "100%", maxWidth: "360px" }}>
        {/* Logo / title */}
        <div style={{ textAlign: "center", marginBottom: "2rem" }}>
          <div
            style={{
              fontSize: "1.75rem",
              fontWeight: 800,
              letterSpacing: "-0.03em",
              lineHeight: 1.1,
              marginBottom: "0.5rem",
            }}
          >
            <span style={{ color: "#2563eb" }}>Chat</span>
            <span style={{ color: "#ffffff" }}> Bot</span>
          </div>
          <p style={{ color: "#71717a", fontSize: "0.875rem", margin: 0 }}>
            Admin
          </p>
        </div>

        {/* Card */}
        <div
          style={{
            background: "#18181b",
            border: "1px solid #27272a",
            borderRadius: "12px",
            padding: "1.75rem",
          }}
        >
          <h2
            style={{
              color: "#ffffff",
              fontSize: "1.125rem",
              fontWeight: 700,
              margin: "0 0 1.25rem 0",
            }}
          >
            Log ind
          </h2>

          <form onSubmit={handleSubmit}>
            {/* Email */}
            <div style={{ marginBottom: "1rem" }}>
              <label
                style={{
                  display: "block",
                  color: "#a1a1aa",
                  fontSize: "0.75rem",
                  fontWeight: 600,
                  textTransform: "uppercase",
                  letterSpacing: "0.08em",
                  marginBottom: "0.4rem",
                }}
              >
                Brugernavn eller e-mail
              </label>
              <input
                type="text"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="din@email.dk"
                required
                autoCapitalize="none"
                autoCorrect="off"
                inputMode="email"
                style={{
                  width: "100%",
                  height: "44px",
                  padding: "0 1rem",
                  borderRadius: "8px",
                  background: "#09090b",
                  border: "1px solid #3f3f46",
                  color: "#ffffff",
                  fontSize: "1rem",
                  outline: "none",
                  boxSizing: "border-box",
                }}
                onFocus={(e) => (e.target.style.borderColor = "#2563eb")}
                onBlur={(e) => (e.target.style.borderColor = "#3f3f46")}
              />
            </div>

            {/* Password */}
            <div style={{ marginBottom: "1rem" }}>
              <label
                style={{
                  display: "block",
                  color: "#a1a1aa",
                  fontSize: "0.75rem",
                  fontWeight: 600,
                  textTransform: "uppercase",
                  letterSpacing: "0.08em",
                  marginBottom: "0.4rem",
                }}
              >
                Password
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Din adgangskode"
                required
                style={{
                  width: "100%",
                  height: "44px",
                  padding: "0 1rem",
                  borderRadius: "8px",
                  background: "#09090b",
                  border: "1px solid #3f3f46",
                  color: "#ffffff",
                  fontSize: "1rem",
                  outline: "none",
                  boxSizing: "border-box",
                }}
                onFocus={(e) => (e.target.style.borderColor = "#2563eb")}
                onBlur={(e) => (e.target.style.borderColor = "#3f3f46")}
              />
            </div>

            {/* Error */}
            {error && (
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "0.5rem",
                  padding: "0.75rem",
                  borderRadius: "8px",
                  background: "rgba(239,68,68,0.1)",
                  border: "1px solid rgba(239,68,68,0.25)",
                  color: "#f87171",
                  fontSize: "0.875rem",
                  marginBottom: "1rem",
                }}
              >
                <span style={{ flexShrink: 0, marginTop: "1px" }}>&#9888;</span>
                <span>{error}</span>
              </div>
            )}

            {/* Remember me */}
            <label
              style={{
                display: "flex",
                alignItems: "center",
                gap: "0.5rem",
                cursor: "pointer",
                marginBottom: "1.25rem",
                userSelect: "none",
              }}
            >
              <input
                type="checkbox"
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
                style={{ accentColor: "#2563eb", width: "16px", height: "16px", cursor: "pointer" }}
              />
              <span style={{ color: "#a1a1aa", fontSize: "0.875rem" }}>Husk mig</span>
            </label>

            {/* Submit */}
            <button
              type="submit"
              disabled={loading}
              style={{
                width: "100%",
                height: "44px",
                borderRadius: "22px",
                background: loading ? "#1d4ed8" : "#2563eb",
                color: "#ffffff",
                fontWeight: 600,
                fontSize: "0.9375rem",
                border: "none",
                cursor: loading ? "not-allowed" : "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "0.5rem",
                transition: "background 0.2s",
              }}
            >
              {loading ? "Logger ind..." : "Log ind"}
            </button>
          </form>
        </div>

        <p
          style={{
            textAlign: "center",
            color: "#52525b",
            fontSize: "0.75rem",
            marginTop: "1.5rem",
          }}
        >
          Brug dit WordPress-login fra sundahl.nu
        </p>
      </div>
    </div>
  );
}
